import CreateDevice from './CreateDevice'

export default CreateDevice
